const ClickMatrizReferenciaObject = "Click Matriz Referencia Object";
const ClickMatrizReferenciaObjectAction = "Click_Matriz_Referencia_Object_Action";

export default ClickMatrizReferenciaObject;
export { ClickMatrizReferenciaObject, ClickMatrizReferenciaObjectAction };
